export const getTransactionsTags = (state) => {
  return state.constants.transactionsTags;
};
